export default __webpack_public_path__ + "static/media/Lato-Black.91b79026.woff2";